(() => {
  let openDialog = null;
  let opener = null;
  function closeMenu() {
    if (openDialog?.open) openDialog.close();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ms-menu-open]');
    if (button) {
      const dialog = document.getElementById(button.dataset.msMenuOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      opener = button;
      openDialog = dialog;
      button.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ms-menu-is-open');
      dialog.showModal();
      dialog.querySelector('[data-ms-menu-close]')?.focus();
    }
    if (event.target.closest('[data-ms-menu-close]')) closeMenu();
    if (openDialog && event.target === openDialog) {
      const rect = openDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu();
    }
    if (event.target.closest('.ms-menu-dialog a')) closeMenu();
  });
  document.addEventListener('close', event => {
    if (!event.target.matches('.ms-menu-dialog')) return;
    document.documentElement.classList.remove('ms-menu-is-open');
    opener?.setAttribute('aria-expanded', 'false');
    opener?.focus();
    openDialog = null;
  }, true);
  window.matchMedia('(min-width: 1200px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  document.addEventListener('shopify:section:unload', closeMenu);
  function decorateFAQs(scope = document) {
    scope.querySelectorAll('.collapsible-content .accordion details, .ms-faq-resources .accordion details, .faq-accordion details, .ms-product-details > details').forEach(detail => detail.classList.add('ms-faq-detail'));
  }
  function revealHash() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    let current = target;
    while (current) {
      if (current.matches?.('details')) current.open = true;
      current = current.parentElement;
    }
    requestAnimationFrame(() => target.scrollIntoView({block:'start', behavior:'instant'}));
  }
  decorateFAQs();
  revealHash();
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', event => decorateFAQs(event.target));
})();
